import { createSlice } from "@reduxjs/toolkit";
import { LOAD_ALL_COMPANIES, LOAD_SINGLE_COMPANY } from "./CompanyList.saga";

export const companyListSlice = createSlice({
  name: "companyList",
  initialState: {
    byId: {},
    allIds: [],
    totalRecords: 0,
    selectedCompany: null,
    filteredRecords: 0,
    isSingleCompanyLoading: false,
    isLoading: false,
    isSingleCompanyNotFound: false,
  },
  reducers: {
    setAllCompaniesLoadingState: (state, action) => {
      state.isLoading = true;
    },
    setSingleCompanyLoadingState: (state, action) => {
      state.isSingleCompanyLoading = true;
      state.isSingleCompanyNotFound = false;
      state.selectedCompany = null;
    },
    loadAllCompanies: (state, action) => {
      const listObj = {};
      action.payload.companies.forEach((value) => {
        listObj[value.id] = value;
      });
      state.byId = listObj;
      state.allIds = action.payload.companies.map((value) => value.id);
      state.totalRecords = action.payload.totalRecords;
      state.filteredRecords = action.payload.filteredRecords;
      state.isLoading = false;
    },
    loadSingleCompany: (state, action) => {
      state.selectedCompany =
        action.payload && action.payload.length === 1
          ? action.payload[0]
          : null;
      state.isSingleCompanyLoading = false;
      state.isSingleCompanyNotFound = false;
    },
    setSingleCompanyNotFound: (state, action) => {
      state.isSingleCompanyNotFound = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(LOAD_ALL_COMPANIES.ERROR, (state) => {
        state.isLoading = false;
      })
      .addCase(LOAD_SINGLE_COMPANY.ERROR, (state) => {
        state.isSingleCompanyLoading = false;
      })
      .addCase(LOAD_SINGLE_COMPANY.NOT_FOUND, (state) => {
        state.isSingleCompanyLoading = false;
        state.isSingleCompanyNotFound = true;
      });
  },
});

export const {
  setAllCompaniesLoadingState,
  setSingleCompanyLoadingState,
  loadAllCompanies,
  loadSingleCompany,
  setSingleCompanyNotFound,
} = companyListSlice.actions;

export default companyListSlice.reducer;
